// extracted by mini-css-extract-plugin
export default {"root":"zbFEmbXDzGK4dTZ073jy"};